import { Component, inject, ViewChild } from '@angular/core';
import { TranslationService } from 'src/app/shared/translations/services/translation.service';
import { WheelsComponent } from '../wheels/wheels.component';
import { WheelColorComponent } from '../wheel-color/wheel-color.component';

@Component({
  selector: 'app-wheel-and-tire-services',
  templateUrl: './wheel-and-tire-services.component.html',
  styleUrls: ['./wheel-and-tire-services.component.scss'],
  standalone: false
})
export class WheelAndTireServicesComponent {
  @ViewChild(WheelsComponent) wheelsComponent: WheelsComponent;
  @ViewChild(WheelColorComponent) wheelColorComponent: WheelColorComponent;

  public translationService = inject(TranslationService);
  selectedTabIndex = 0;

  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;
  }

  canDeactivate(): Promise<boolean> {
    if (this.selectedTabIndex === 0 && this.wheelsComponent) {
      return this.wheelsComponent.canDeactivate();
    }
    if (this.selectedTabIndex === 1 && this.wheelColorComponent) {
      return this.wheelColorComponent.canDeactivate();
    }
    return Promise.resolve(true);
  }
}
